import 'whatwg-fetch';
import { Logout, TokenRefresh } from '../actions/auth.actions';
import { store } from '../store';

const baseUrl = process.env.REACT_APP_API_BASE_URL;

// tslint:disable:no-any

export function http(url: string, body: any, method: string = 'GET', headers?: Headers, options: RequestInit = {}) {
  const h = headers || new Headers();
  h.append('Content-Type', 'application/json');

  return fetch(`${baseUrl}/${url}`, {
    ...options,
    body: typeof body === 'string' ? body : JSON.stringify(body),
    headers: h,
    method,
    mode: 'cors',
  })
  .then((response) => {

    if (response.status === 401) {
      store.dispatch(Logout());
      return response.json();
    }

    const newToken = response.headers.get('x-access-token');
    if (newToken) {
      store.dispatch(TokenRefresh(newToken));
    }
    if (response.json) {
      return response.json();
    }
    return response;
  });
}

export function get(url: string, headers?: Headers, options: RequestInit = {}) {
  return http(url, undefined, 'GET', headers);
}

export function post(url: string, body: any, headers?: Headers, options: RequestInit = {}) {
  return http(url, body, 'POST', headers);
}

export function del(url: string, headers?: Headers, options: RequestInit = {}) {
  return http(url, undefined, 'DELETE', headers);
} 

export function put(url: string, body: any, headers?: Headers, options: RequestInit = {}) {
  return http(url, body, 'PUT', headers);
}

// tslint:enable:no-any
